/**
 * Created by Jan Bradac on 3.6.2016.
 */


FunctionsCaller.register(function ($) {
    $(document).click(function (event) {
        var $clickover = $(event.target);
        var $navbar = $(".navbar-collapse");
        var _opened = $navbar.hasClass("in");
        if (_opened === true && !$clickover.hasClass("navbar-collapse") && !$clickover.parents(".navbar-collapse").length) {
            $navbar.collapse('hide');
        }
    });
});